/* eslint no-use-before-define: "off" */

export { getHostname };

const getHostname = () => {
  const host = window.location.hostname.split('.')[0];
  switch (host) {
    case 'stage':
      return 'stage';
    case 'localhost':
    case 'local.echobox.com':
      return 'dev';
    default:
      return 'live';
  }
};
